import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_CONTACTS, SET_CLIENT} from 'vx/mutations'



// Contact state.
const state = {
  client_id: null,
  contacts: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  contacts: state => state.contacts,

  getById: (state) => (id) => {
    return state.contacts.find(contact => contact.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of contacts.
   */
  getContacts ({ commit }, id, payload) {
    return http.get(`/clients/`+id+`/contacts/list`).then(response => {
      commit(SET_CONTACTS, response.data)
      commit(SET_CLIENT, id)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the contacts state.
  */
  [SET_CONTACTS] (state, contacts) {
    state.contacts = contacts
  },

  /**
  * Set the clients state.
  */
 [SET_CLIENT] (state, client_id) {
    state.client_id = client_id
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
